import Promise from 'bluebird';
import { useMemo, useCallback } from 'react';
import { FilterStorageFactory } from '@bingads-webui-campaign/filter-storage';
import { useGlobalFilterContext } from '@bingads-webui-react/global-filter-context';

function getAdFilterStore(preferenceService) {
  const adFilterFactory = new FilterStorageFactory({
    preferenceService,
    featureName: 'AdGrid',
    entityName: 'Ad',
  });
  const adFilterStore = adFilterFactory.create('editableFilter', {
    filterEntityOptions: {
      entitySchema: { name: 'Ad' },
    },
  });
  return adFilterStore;
}

export const useAdFilter = ({ preferenceService }) => {
  const { updateWaterfallFilter } = useGlobalFilterContext();

  const adFilterStore = useMemo(
    () => (preferenceService ? getAdFilterStore(preferenceService) : null),
    [preferenceService]
  );

  // wrap save method to wait remote preference updating done
  const saveFilter = useCallback((filter, waitRemote) => {
    // delete first and then create
    let deletePromise = adFilterStore.clean() || Promise.resolve();
    if (waitRemote) {
      const remoteSyncTasks = preferenceService.onRemoteSyncDone(1);
      // eslint-disable-next-line no-unused-vars
      deletePromise = deletePromise.then(() => remoteSyncTasks).catch((err) => { /* ignore */ });
    }

    let savePromise = adFilterStore.save(filter);
    if (waitRemote) {
      const remoteSyncTasks = preferenceService.onRemoteSyncDone(1);
      savePromise = savePromise.then(() => remoteSyncTasks);
    }

    return deletePromise.then(() => savePromise);
  }, [adFilterStore, preferenceService]);

  const adFilterStoreWrapper = useMemo(() => ({ ...adFilterStore, save: saveFilter }), [adFilterStore, saveFilter]);

  return {
    updateWaterfallFilter,
    adFilterStore: adFilterStoreWrapper,
  };
};
